module.exports = __webpack_public_path__ + "media/images/about__our-culture-1-e3478b6a3812264fc762cfb32a0cd2d8.jpg";